import { render } from "./WhyShopWithUs.vue?vue&type=template&id=f12dccd6"
const script = {}

import "./WhyShopWithUs.vue?vue&type=style&index=0&id=f12dccd6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__